import { allValues, Rights } from '../rights';

export const NURSING_MANAGEMENT_RIGHTS = Object.freeze([
  ...allValues(Rights.RESIDENTS),
  Rights.EMPLOYEES.READ.key,
  Rights.EMPLOYEES.WRITE.key,
  ...allValues(Rights.EMPLOYEES.GENERAL),
  ...allValues(Rights.EMPLOYEES.CONTRACT),
  ...allValues(Rights.EMPLOYEES.SYSTEM_ACCESS),
  ...allValues(Rights.EMPLOYEES.CHECKLIST),
  ...allValues(Rights.EMPLOYEES.FILES),
  ...allValues(Rights.BASE_DATA),
  ...allValues(Rights.CARE),
  Rights.ADMINISTRATION_AND_INVOICING.BACKUP.key,
  ...allValues(Rights.ADMINISTRATION_AND_INVOICING.PAYER),
  Rights.ADMINISTRATION_AND_INVOICING.INVOICE.READ.key,
  Rights.GENERAL.CASH_AMOUNT.READ.key,
  Rights.GENERAL.CASH_AMOUNT.WRITE.key,
  ...allValues(Rights.GENERAL.CALENDAR),
  ...allValues(Rights.GENERAL.CONTACTS),
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.ROSTER.MANAGE.key,
  Rights.ROSTER.ADMINISTRATE.key,
  Rights.ROSTER.PRINT.key,
  Rights.ROSTER.ACCESS.READ.key,
  Rights.ROSTER.ACCESS.WRITE.key,
  Rights.ROSTER.WEEK_PLAN.key,
  ...allValues(Rights.LISTS),
  ...allValues(Rights.ROSTER.VACATION_SCHEDULE),
]);
